
import CustomerLineItem from "../events/event/cart/customer-line-item";
import UserCheckoutInfo from "../events/event/cart/user-checkout-info";
import { useSelector } from "react-redux";
import { selectRegistrationCustomer } from "../../reducers/registrationOrderSlice";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";
import { getCurrentUser } from "../../app/gs-session";

const CartContactWidget = () => {

  const customer = useSelector(selectRegistrationCustomer);
  const navigate = useGolfstatusNavigate()
  const isLoggedIn = !!getCurrentUser()?.uid;


  if(customer?.firstName) {
    return <CustomerLineItem
    {...customer}
    editClick={() => {
      navigate("customer");
    }}
  />
  }

  return <UserCheckoutInfo isLoggedIn={isLoggedIn} />
}

export default CartContactWidget